var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('order-channel-type-form',{model:{value:(_vm.order_channel_type),callback:function ($$v) {_vm.order_channel_type=$$v},expression:"order_channel_type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }